import { Box, SegmentGroup, SegmentGroupRootProps } from '@chakra-ui/react'

export const Segmented = ({
  options,
  value,
  onChange,
  palette = 'orange',
  size,
  containerProps,
}: {
  options: string[]
  value: string
  onChange: (v: string) => void
  palette?: string
  size?: 'xs' | 'sm' | 'md' | 'lg'
  containerProps?: SegmentGroupRootProps
}) => (
  <Box bgColor={'colorPalette.container'} borderRadius={'md'} padding={1}>
    <SegmentGroup.Root
      colorPalette={palette}
      size={size}
      value={value}
      width={'full'}
      onValueChange={e => onChange(e.value ?? '')}
      {...containerProps}
    >
      <SegmentGroup.Indicator />
      <SegmentGroup.Items flex={'1'} items={options} justifyContent={'center'} />
    </SegmentGroup.Root>
  </Box>
)
